// Copyright (c) 2018 Deere & Company

import {translate} from '../../../shared/services/translation-service';

export const getProductSearchColumns = () => ({
    listColumns: [
        {
            id: 'pin',
            key: translate('PIN')
        },
        {
            id: 'model',
            key: translate('MODEL')
        },
        {
            id: 'baseMachine',
            key: translate('BASE_MACHINE')
        },
        {
            id: 'dealer',
            key: translate('DEALER')
        },
        {
            id: 'machineStatus',
            key: translate('MACHINE_STATUS')
        },
        {
            id: 'customer',
            key: translate('CUSTOMER')
        },
        {
            id: 'pip',
            key: translate('PIP')
        },
        {
            id: 'amountOfUse',
            key: translate('AMOUNT_OF_USE')
        },
        {
            id: 'activeWarranty',
            key: translate('ACTIVE_WARRANTY')
        }
    ],
    listId: 'productSearch'
});



// WEBPACK FOOTER //
// ./src/product/search/services/excel-columns.js